import { supabase } from '@/lib/supabase';

export const deleteProjectKpi = async (id: number): Promise<void> => {
  const { error } = await supabase.from('project_kpis').delete().eq('id', id);

  if (error) {
    throw error;
  }
};

export const deleteDerivativeKpi = async (id: number): Promise<void> => {
  const { error } = await supabase
    .from('derivative_kpis')
    .delete()
    .eq('id', id);

  if (error) {
    throw error;
  }
};

export const deleteAssignedKpi = async (id: string): Promise<void> => {
  const { error } = await supabase.rpc('delete_assigned_kpi', {
    p_budget_id: id,
  });

  if (error) {
    throw error;
  }
};
